import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useGetCuisineQuery } from "../../../api/cuisine";

export default function TagButton() {
  const { data: cuisine } = useGetCuisineQuery();
  console.log("cuisine", cuisine?.data);
  const realData = cuisine?.data;
  console.log(realData)
  const data = [
    {
      id: "1",
      title: "All Cuisines",
    },
    {
      id: "1",
      title: "American",
    },
    {
      id: "1",
      title: "Italian",
    },
    {
      id: "1",
      title: "Mexican",
    },
    {
      id: "1",
      title: "Chinese",
    },
    {
      id: "1",
      title: "Mexican",
    },
    {
      id: "1",
      title: "Japanese",
    },
  ];
  return (
    <>
      <Box
        sx={{
          mt: "30px",
        }}
      >
        <Grid container spacing={1}>
          {realData &&
            realData.map((v, i) => {
              return (
                <>
                  <Box
                    xs={7}
                    sx={{
                      width: "auto",
                      height: "30px",
                      display: "flex",
                      flexDirection: {
                        lg: "row",
                        md: "row",
                        sm: "column",
                        xs: "column",
                      },
                      // alignItems:'center',
                      // justifyContent:'center',
                      paddingLeft: "8px",
                      paddingBottom: "15px",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{ width: "auto", padding: "6px" }}
                        className="dishes"
                      >
                        {v.cuisine}
                      </Typography>
                    </Box>
                  </Box>
                </>
              );
            })}
        </Grid>
      </Box>
    </>
  );
}
